export default __webpack_public_path__ + "static/media/vAave.6bf540ce.svg";